import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import MySelect from '@/components/MySelect.vue';
import { range } from 'lodash';
import ClassDetail from '@/components/ClassDetail.vue';
let CharacterBuilderClassNew = class CharacterBuilderClassNew extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.chosenClass = '';
        this.range = range;
    }
    get classChoices() {
        const currentClassList = this.currentClasses.map(({ name }) => name);
        return this.classes.map(({ name }) => name).filter(name => !currentClassList.includes(name));
    }
    get classData() {
        return this.classes.find(({ name }) => name === this.chosenClass);
    }
    handleAdd() {
        this.$emit('add', this.chosenClass);
        this.isOpen = false;
    }
};
__decorate([
    Prop(Array)
], CharacterBuilderClassNew.prototype, "classes", void 0);
__decorate([
    Prop(Array)
], CharacterBuilderClassNew.prototype, "currentClasses", void 0);
__decorate([
    Prop(Number)
], CharacterBuilderClassNew.prototype, "currentLevel", void 0);
CharacterBuilderClassNew = __decorate([
    Component({
        components: {
            MyDialog,
            MySelect,
            ClassDetail
        }
    })
], CharacterBuilderClassNew);
export default CharacterBuilderClassNew;
